module.exports = __webpack_public_path__ + "45a2c4bbeddcd0face891cca390a7cb8.png";